import { useEffect, useState } from "react"
import Badge from "../../components/badge";
import Box from "../../components/box";
import Card from "../../components/card";
import { useLayoutContext } from "../../context/game"
import './question.scss';

export default function Questions({setRoute,count}){
	const questionList = window['game_data']['questions'] || {};
	const [questions] = useState(questionList)
	const [context,setContext] = useLayoutContext();
	const onClickQuestion = (qId) =>{
		setRoute('question');
		setContext({current:qId,hasStarted:true});
	}

	if (Object.keys(questionList).length === 0) {
		return (
			<div className="row g-0 px-3">
				<div className="col-xl-6 col-lg-8 mx-auto py-5">
					<Card className="align-items-center">
						<svg className='mb-4' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="72" height="72"><path fill="none" d="M0 0h24v24H0z" /><path fill='#F5B736' d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-5h2v2h-2v-2zm0-8h2v6h-2V7z" /></svg>
						<h2>Žaidimo peržiūra bus sugeneruota kai užpildysite bent vieną įrašą.</h2>
					</Card>
				</div>
			</div>
		)
	}
	return(<div className="position-relative py-5 flex-grow-1">
		<div className='game-bg'></div>
		<div className="container">
			<div className="vpe-card py-5">
				<div className="text-center mb-5">
					<Badge className='d-inline-block heads fw-600'>
						Pasirink kortelę
					</Badge>
				</div>
				<div className="row justify-content-center">
					{questions && Object.keys(questions).map((qId)=>{
						const {title} = questions[qId];
						let correct = null;
						if (context?.wrong){
							const isWrong = context.wrong.includes(qId);
							if(isWrong){
								correct = false
							}	
						}
						if(context?.answered){
							const answer = context.answered[qId];
							const isCorrect = window['game_data']['answers'][qId] === answer;
							if(isCorrect) {
								correct = isCorrect;
							}
						} 
						return(
							<div className="col-lg-4 mb-4" key={qId}>
								<Box 
									title={title} 
									onClick={()=>{correct !== true && onClickQuestion(qId)}} 
									isCorrect={correct}
								/>
							</div>
						)
					})}
				</div>
			</div>
		</div>
	</div>)
}